'use client'

import { Button } from '@/components/v2/Button'
import { Input } from '@/components/v2/Input'
import { Label } from '@/components/v2/Label'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/v2/Sheet'
import React, { useState } from 'react'

export function DrawerBottom({
  children,
  open,
}: {
  children: React.ReactNode
  open: boolean
}) {
  const position = 'bottom'

  return (
    <div className="grid grid-cols-2 gap-2">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="outline">{position}</Button>
        </SheetTrigger>
        <SheetContent side={position}>{children}</SheetContent>
      </Sheet>
    </div>
  )
}

// TODO: Global state to avoid recreating the Drawer in case of recreating the parent component
export const useDrawerBottom = (id: string) => {
  const [contentState, setContentState] = useState<JSX.Element | null>(null)
  const position = 'bottom'

  return {
    setContent: (content: JSX.Element | null) => {
      setContentState(content)
    },
    Drawer: () => (
      <Sheet
        open={!!contentState}
        onOpenChange={(open) => {
          if (!open) setContentState(null)
        }}
      >
        {/* <SheetTrigger asChild>
          <Button variant="outline">{position}</Button>
        </SheetTrigger> */}
        <SheetContent id={id} className="p-0" side={position}>
          {contentState}
        </SheetContent>
      </Sheet>
    ),
  }
}
